import { MouseEvent, ReactNode } from 'react';
import classNames from 'classnames';

import { OptionalEngagementProps } from '@hcs/types';

import { addOptionalEngagementProps } from '../../../../utils/engagement-props.utils';

import styles from './TextButton.module.css';

export interface TextButtonProps extends OptionalEngagementProps {
  /** Data attribute for automated testing */
  dataHcName: string;
  /** Class to apply to the root element */
  className?: string;
  /** Label to render in place of children */
  label?: ReactNode;
  /** Whether the button is clickable */
  disabled?: boolean;
  /** Callback when button is clicked */
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  /** Use primary styles */
  primary?: boolean;
  children?: ReactNode;
  title?: string;
  noPadding?: boolean;
  type?: 'button' | 'submit' | 'reset';
  /**
   * Adds an icon to the button. Accepts a react component.
   */
  icon?: ReactNode;
  /**
   * Determines icon orientation. Defaults to `left`.
   */
  iconPosition?: 'left' | 'right';
}

export const TextButton = (props: TextButtonProps) => {
  const {
    children,
    className,
    label,
    disabled,
    onClick,
    dataHcName,
    type = 'button',
    dataHcEventData,
    primary = true,
    title,
    noPadding = false,
    icon,
    iconPosition,
    ...restProps
  } = props;
  return (
    <button
      className={classNames(styles.TextButton, className, {
        [styles.secondary]: !primary,
        [styles.disabled]: disabled,
        [styles.noPadding]: noPadding,
        [styles.iconRight]: icon && iconPosition === 'right',
      })}
      type={type}
      data-hc-name={dataHcName}
      {...addOptionalEngagementProps(restProps)}
      onClick={!disabled ? onClick : undefined}
      title={title}
    >
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      {children || label}
    </button>
  );
};
